module.exports = __webpack_public_path__ + "static/media/29_A.7cceb4a5.png";